import React from 'react';
import ArrowUpWhite from 'src/assets/images/icons/arrow-link-up-collapse-small_white.svg';
import { t } from 'i18next';

export const ExpandLess = () => {
  return <img src={ArrowUpWhite} alt={t('ArrowUpAltText')} />;
};
